import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PageMeta from '../SEO/PageMeta';
import logoImg from '../../assets/logo.png';
import './Pages.css';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });
const EMAIL = 'imomujjwalsingh@gmail.com';

const FIND = [
  ['X', 'https://twitter.com/civilfox_in'],
  ['Instagram', 'https://instagram.com/civilfox_in'],
  ['LinkedIn', 'https://linkedin.com/company/civilfox'],
  ['WhatsApp', 'https://chat.whatsapp.com/REPLACE_WITH_LINK'],
  ['Slack', 'https://civilfox.slack.com'],
];

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      await api.post('/public/contact', form);
      setStatus('success');
      setForm({ name: '', email: '', message: '' });
    } catch { setStatus('error'); }
  };

  return (
    <div className="pg">
      <PageMeta
        title="Contact CivilFox | UPSC Study Platform"
        description="Contact the CivilFox team with questions, feedback, or support requests about UPSC PYQs, current affairs, mock tests, and study tools."
        path="/contact"
      />
      <header className="pg-top">
        <Link to="/" aria-label="CivilFox home"><img src={logoImg} alt="CivilFox" /></Link>
      </header>
      <main className="pg-main">
        <h1>Contact CivilFox</h1>
        <p>Send the CivilFox team a question, suggestion, or support request.</p>
        <div className="pg-contact">
          <form className="pg-form" onSubmit={submit}>
            <input className="pg-in" type="text" placeholder="Name" aria-label="Name" required value={form.name} onChange={set('name')} />
            <input className="pg-in" type="email" placeholder="Email" aria-label="Email" required value={form.email} onChange={set('email')} />
            <textarea className="pg-in" rows={5} placeholder="Message" aria-label="Message" required value={form.message} onChange={set('message')} />
            {status === 'success' && <p className="pg-msg ok" role="status">Sent.</p>}
            {status === 'error' && <p className="pg-msg err" role="alert">Not sent. Email <a href={`mailto:${EMAIL}`}>{EMAIL}</a></p>}
            <button className="pg-btn" type="submit" disabled={status === 'loading'}>
              {status === 'loading' ? 'Sending…' : 'Send'}
            </button>
          </form>

          <div className="pg-find">
            <a className="mail" href={`mailto:${EMAIL}`}>{EMAIL}</a>
            {FIND.map(([name, href]) => (
              <a key={name} href={href} target="_blank" rel="noopener noreferrer">{name}</a>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}